<template>
  <LetterGreen
    class="pt-1 ml-1 mb-1"
    :class="selected ? 'white-icon' : ''"
    style="display: inline-block;"
    width="20px"
    height="20px"
  ></LetterGreen>
  <span class="text-green text-lg font-bold">メッセージ</span>
  <span
    v-if="!getSentBackItemMessage('office_message')[0]?.isNewest"
    class="text-green text-lg"
  >
    | 新規メッセージはありません</span
  >
  <div class="ml-1">
    <AppSentBackItem
      color="green"
      :message="getSentBackItemMessage('office_message')"
    />
  </div>
</template>

<script>
import LetterGreen from '@/assets/icons/letter-green.svg?inline'
import AppSentBackItem from '@/components/ui/AppPreviewSentBackItem'
import { useReceiptForm } from '@/services/receiptsOsaka/useReceiptForm'

export default {
  name: 'AppOfficeMessageOsaka',

  components: { LetterGreen, AppSentBackItem },

  setup() {
    const { getSentBackItemMessage } = useReceiptForm()
    return { getSentBackItemMessage }
  },
}
</script>

<style lang="scss" scoped></style>
